import React from 'react';
import { PollOverview } from 'api/api.types';
import { useTranslation } from 'react-i18next';
import formatDate from 'utils/formatDate';
import { Link } from 'react-router-dom';
import useElectionTeaserTitle from 'lib/PollTeaser/useElectionTeaserTitle';
import { isPoll } from 'utils/poll';
import { getInternalUrl } from 'utils/routing';

interface Props {
  issue: PollOverview;
}

const ArchiveIssueTeaser = ({ issue }: Props) => {
  const { t } = useTranslation('wap');
  const title = useElectionTeaserTitle(issue);

  const getMetaInfo = () => {
    const date = formatDate(issue.date);
    const type = isPoll(issue.type) ? t('poll') : t('election');
    const metaInfo = [date, type];

    if ('proportional_election_info' in issue && issue.proportional_election_info) {
      metaInfo.push(t('seats', { count: issue.proportional_election_info?.seat_count }));
    } else if (isPoll(issue.type)) {
      metaInfo.push(issue.scope === 'cantonal' ? t('cantonal') : t('federal'));
    } else {
      metaInfo.push(t('seats', { count: issue.majority_election_info?.seat_count }));
      metaInfo.push(t('round', { count: issue.majority_election_info?.round_number }));
    }

    return metaInfo;
  };

  const metaInfos = getMetaInfo();

  return (
    <Link to={getInternalUrl(issue, 'poll')}>
      <div className="issueteaser__inner">
        <div className="issueteaser__info">
          <h2 className="issueteaser__title">{title}</h2>
          <ul className="issueteaser__meta">
            {metaInfos.map((metaItem) => (
              <li key={metaItem}>{metaItem}</li>
            ))}
          </ul>
        </div>
        <div className="issueteaser__result">
          {/* TODO: add results when available */}
          {/* {isPoll(issue.type) ? (
          <PollTeaserResult />
        ) : (
          <ElectionTeaserResult />
        )} */}
        </div>
      </div>
    </Link>
  );
};

export default ArchiveIssueTeaser;
